<script setup lang="ts">
import { SelectRoot, useForwardPropsEmits } from 'reka-ui'
import type { SelectRootEmits, SelectRootProps } from 'reka-ui'

defineOptions({
    compatConfig: {
        MODE: 3,
    },
})

const props = defineProps<SelectRootProps>()
const emits = defineEmits<SelectRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
    <SelectRoot
        v-slot="slotProps"
        data-slot="select"
        v-bind="forwarded"
    >
        <slot v-bind="slotProps"></slot>
    </SelectRoot>
</template>
